import Liability from "../models/household/Liability";
import axios from 'axios';

export default {
    namespaced: true,

    getters: {
        liabilities() {
            return Liability.all();
        },
        householdLiabilities() {
            return (householdId) => Liability.query().where('household_id', householdId).get();
        },
        getLiability() {
            return (id) => Liability.find(id);
        }
    },

    actions: {
        loadLiabilities({commit}, {householdId}) {
            return axios
                .get(`api/household/${householdId}/liabilities`)
                .then((response) => {
                        commit('LIABILITIES_LOADED', response.data.data.liabilities);
                        return response;
                    }
                );
        },
    },

    mutations: {
        ['LIABILITIES_LOADED'](state, data) {
            if (data) {
                Liability.create({data});
            }
        },
    }
}
